import { useEffect } from 'react'

export function Home() {
  useEffect(() => {
    window.location.href = 'https://reown.com'
  }, [])

  return null
}
